import { render, staticRenderFns } from "./OrganizationList.vue?vue&type=template&id=e2136ddc&scoped=true"
import script from "./OrganizationList.vue?vue&type=script&lang=js"
export * from "./OrganizationList.vue?vue&type=script&lang=js"
import style0 from "./OrganizationList.vue?vue&type=style&index=0&id=e2136ddc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2136ddc",
  null
  
)

export default component.exports